module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_8023.e08984a4.png";